export default "__VITE_ASSET__jJM1uqdY__"